import { Injectable } from "@angular/core";
import {
  ITag,
  ITagApiResponse,
  ITagDetailApiResponse,
  ITagProductsApiResponse,
} from "../pages/tags/models/tag.model";
import { RequestService } from "./request/request.service";

@Injectable({
  providedIn: "root",
})
export class TagService {
  constructor(private readonly requestService: RequestService) {}

  getTags(params: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string | null;
    type?: string | null;
    iso2?: string | null;
  }) {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append("page", params.page.toString());
    if (params.limit) queryParams.append("limit", params.limit.toString());
    if (params.search) queryParams.append("search", params.search);
    if (params.status !== null && params.status !== undefined) {
      queryParams.append("status", params.status);
    }
    if (params.type) queryParams.append("type", params.type);
    if (params.iso2) queryParams.append("iso2", params.iso2);

    return this.requestService.get<ITagApiResponse>(`/api/v2/tags?${queryParams.toString()}`);
  }

  getTag(tagId: number) {
    return this.requestService.get<ITagDetailApiResponse>(`/api/v2/tags/${tagId}`);
  }

  createTag(tag: Partial<ITag>) {
    return this.requestService.post<ITagApiResponse>("/api/v2/tags", tag);
  }

  updateTag(tagId: number, tag: Partial<ITag>) {
    return this.requestService.put<ITagApiResponse>(`/api/v2/tags/${tagId}`, tag);
  }

  deleteTag(tagId: number) {
    return this.requestService.delete<ITagApiResponse>(`/api/v2/tags/${tagId}`);
  }

  getTagProducts(
    tagId: number,
    params: {
      page?: number;
      limit?: number;
      search?: string;
      status?: string | null;
    }
  ) {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append("page", params.page.toString());
    if (params.limit) queryParams.append("limit", params.limit.toString());
    if (params.search) queryParams.append("search", params.search);
    if (params.status !== null && params.status !== undefined) {
      queryParams.append("status", params.status);
    }

    return this.requestService.get<ITagProductsApiResponse>(
      `/api/v2/tags/${tagId}/products?${queryParams.toString()}`
    );
  }

  autocompleteTags(params: {
    query?: string;
    limit?: number;
    type?: string | null;
    iso2?: string | null;
  }) {
    const queryParams = new URLSearchParams();
    if (params.query) queryParams.append("query", params.query);
    if (params.limit) queryParams.append("limit", params.limit.toString());
    if (params.type) queryParams.append("type", params.type);
    if (params.iso2) queryParams.append("iso2", params.iso2);

    return this.requestService.get<ITagApiResponse>(
      `/api/v2/tags/autocomplete?${queryParams.toString()}`
    );
  }

  ensureTagsExist(tagNames: string[], type = "general") {
    return this.requestService.post<ITagApiResponse>("/api/v2/tags/ensure-exist", {
      tagNames,
      type,
    });
  }

  addTagToProducts(tagId: number, productIds: number[]) {
    return this.requestService.post<ITagApiResponse>(`/api/v2/tags/${tagId}/add-products`, {
      productIds,
    });
  }
}
